import { useState, useEffect } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Hook para buscar todos os agregados mensais de agendamentos em tempo real
 * Reduz drasticamente leituras do Firebase e atualiza automaticamente
 */
export const useAppointmentsAggregate = () => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    // Listener em tempo real para a coleção de agregados
    const appointmentsAggregatesCollection = collection(db, 'agregadoAgendamentos');
    
    const unsubscribe = onSnapshot(
      appointmentsAggregatesCollection,
      (aggregatesSnapshot) => {
        try {
          const allAppointments = [];
          
          aggregatesSnapshot.forEach((doc) => {
            const data = doc.data();
            const appointmentsArray = data.appointments || [];
            
            // Adicionar todos os agendamentos deste mês ao array geral
            appointmentsArray.forEach((appointment) => {
              let appointmentDate;
              if (appointment.dataAgendamento?.toDate) {
                appointmentDate = appointment.dataAgendamento.toDate();
              } else if (appointment.dataAgendamento instanceof Date) {
                appointmentDate = appointment.dataAgendamento;
              } else if (appointment.dataAgendamento) {
                appointmentDate = new Date(appointment.dataAgendamento);
              } else {
                return; // Pular agendamentos sem data válida
              }
              
              allAppointments.push({
                ...appointment,
                dataAgendamento: appointmentDate
              });
            });
          });
          
          // Ordenar todas as agendamentos por data (mais recente primeiro)
          allAppointments.sort((a, b) => {
            const dateA = a.dataAgendamento instanceof Date ? a.dataAgendamento : new Date(a.dataAgendamento);
            const dateB = b.dataAgendamento instanceof Date ? b.dataAgendamento : new Date(b.dataAgendamento);
            return dateB.getTime() - dateA.getTime();
          });
          
          setAppointments(allAppointments);
          setLoading(false);
        } catch (err) {
          setError(err);
          setLoading(false);
        }
      },
      (err) => {
        // Callback de erro do onSnapshot
        setError(err);
        setLoading(false);
      }
    );

    // Cleanup: remover listener quando o componente desmontar
    return () => {
      unsubscribe();
    };
  }, []);

  return { appointments, loading, error };
};
